<template>
  <v-row>
    <v-col cols="6" md="4">
      <div v-if="isGlobalDefaults" class="font-weight-bold">Default Settings</div>
      <div class="d-flex flex-row justify-space-between align-center">
        <span>Locations</span>
        <v-switch
          class="mt-0 pt-0"
          :label="isCorporate ? 'All locations' : 'All assigned'"
          hide-details
          v-model="locationMode"
          @change="$emit('location-mode-change', $event)"
          false-value="manual"
          true-value="assigned"
        ></v-switch>
      </div>
      <EsAutocomplete
        multiple
        chips
        :items="locations"
        itemText="name"
        itemValue="id"
        :itemsToShow="1"
        :label="selectedLocationsLabel"
        single-line
        :value="selectedLocationsValue"
        @input="
          $emit(
            'selected-locations-change',
            $event.map((id) => ({
              locationId: id,
              notificationType: notificationTypeId,
              userId,
            }))
          )
        "
        hide-details
        :disabled="
          locationMode ===
            'assigned'
        "
      />
    </v-col>
    <v-col cols="1">
      <div
        class="d-flex align-center justify-center overline"
        :class="{'mt-6': isGlobalDefaults, 'mt-3': !isGlobalDefaults }"
        style="height: 100%"
      >
        AND
      </div>
    </v-col>
    <v-col cols="5" md="4">
      <div :class="{ 'mt-6': isGlobalDefaults }">Request Priorities</div>
      <EsSelect
        multiple
        chips
        :sort="false"
        :items="['Emergency', 'High', 'Medium', 'Low']"
        :value="selectedRequestPriorities.map((loc) => loc.requestPriority)"
        @input="
          $emit(
            'request-priorities-change',
            $event.map((p) => ({
              requestPriority: p,
              notificationType: notificationTypeId,
              userId,
            }))
          )
        "
        :label="requestPrioritiesLabel"
        single-line
        :itemsToShow="4"
        hide-details
      />
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "EsNotificationDefaultSettings",
  props: {
    locationMode: {
      type: String,
      default: 'assigned',
    },
    locations: {
      type: Array,
      default: () => [],
    },
    selectedLocations: {
      type: Array,
      default: () => [],
    },
    selectedRequestPriorities: {
      type: Array,
      default: () => [],
    },
    isCorporate: {
      type: Boolean,
      required: true,
    },
    userId: {
      type: String,
      required: false,
    },
    notificationTypeId: {
      type: String,
      required: false,
    },
    isGlobalDefaults: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    requestPrioritiesLabel() {
      return !this.selectedRequestPriorities.length ? "All" : "";
    },
    selectedLocationsLabel() {
      return this.locationMode === "assigned"
        ? this.isCorporate
          ? "All locations"
          : "All assigned"
        : !this.selectedLocations.length
        ? "None"
        : "";
    },
    selectedLocationsValue() {
      return this.locationMode === "assigned"
        ? []
        : this.selectedLocations.map((loc) => loc.locationId);
    },
  },
};
</script>
